import SimpleTableList from '@/components/forms/SimpleTableList'
import TableColumn from '@/components/forms/TableColumn'
import Tables from '@/components/forms/Tables'
import Tools from '@/components/tools/Tools'
import LpuPciRepository from '@/shared/http/repositories/pci/lpupci'
import PCILayoutContaRepository from '@/shared/http/repositories/pci/pcilayoutconta'
import TecAnalysisRepository from '@/shared/http/repositories/pci/tecanalysis'
import TecAnalysisItemRepository from '@/shared/http/repositories/pci/tecanalysisitem'
import TecAnalysisDetailItemRepository from '@/shared/http/repositories/pci/tecanalysisitemdetail'
import ServiceAnalysisTecRepository from '@/shared/http/repositories/pci/tecserviceanalysis'
import ServiceAnalysisTecNaRepository from '@/shared/http/repositories/pci/tecserviceanalysisna'
import recordAccessControl from '@/shared/mixins/recordAccessControl'
import Roles from '@/shared/utils/roles'
import { loading, toast } from '@/shared/utils/UIHelper'
import permissionMixin from '@/store/module/permission/mixin'
import { AgGridVue } from 'ag-grid-vue'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import NumberEditor from '../../components/NumberEditor'
import gridMixin from '../../mixins/gridMixin'
import Additive from './additive.vue'
import tecAnalysisTypes from './tecanalysistypes'
import { empty } from 'uuidv4'

export default {
  name: 'TecAnalysis',
  mixins: [gridMixin, permissionMixin, recordAccessControl],
  components: {
    AgGridVue,
    NumberEditor,
    Additive,
    Tables,
    TableColumn,
    SimpleTableList
  },
  data () {
    return {
      itemRowClassRules: null,
      atRowClassRules: null,
      objListLpu: [],
      objListLpuToChange: [],
      objListQuotesToImport: [],
      lpuToChangeID: null,
      objList: [],
      objListAll: [],
      originalValues: [],
      roles: Roles,
      showAll: false,
      clone: false,
      lpuPciID: null,
      at: null,
      block: {},
      viewLog: false,
      viewLogRes: false,
      pci: {},
      pcis: [],
      works: [],
      sitesDesmembrar: [],
      extraItems: [],
      logTec: [],
      logTecRes: [],
      tecAnalysisItems: [],
      tecAnalysisItemsOrig: [],
      serviceAnalysisTecList: [],
      serviceAnalysisTec: [],
      serviceAnalysisTecSelected: null,
      serviceAnalysisTecNa: [],
      newObservation: '',
      editingObs: null,
      editing: false,
      approving: true,
      obsReject: '',
      obsReview: '',
      moneyFactor: 1,
      regionFactor: 1,
      taxesFactor: 1,
      additive: null,
      scrollAllItems: false,
      showRevisions: false,
      tecAnalysisType: 0,
      tecAnalysisTypes: tecAnalysisTypes,
      statusApprove: {
        PENDENTE: 0,
        REJEITADO_PLANEJAMENTO: 1,
        REJEITADO_ORCAMENTO: 2,
        EM_DIGITACAO: 5,
        EM_REV_PLANEJAMENTO: 10,
        EM_REV_ORCAMENTO: 12,
        AG_APROV_REGIONAL_PLAN: 16,
        AG_APROV_REGIONAL_ORC: 18,
        AG_APROV_PLANEJAMENTO: 20,
        AG_APROV_ORCAMENTO: 22,
        APROVADA: 50,
        CANCELADA: 60
      },
      gridOptionsTecAnalysis: {},
      gridOptionsTecAnalysisItems: {},
      gridOptionsQuotes: {},
      gridPopupParent: null,
      columnDefs: [
        {
          headerName: this.$lang.PCI.AT.Datatable.Item,
          field: 'sequencia',
          width: 70,
          minWidth: 70,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.ClientDescription,
          field: 'analiseTecItemDetalhe.descricaoCliente',
          type: 'memoColumn',
          cellRendererParams: {
            placement: 'bottomright'
          },
          width: 350,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Description,
          field: 'descricao',
          type: 'memoColumn',
          cellRendererParams: {
            placement: 'bottomright'
          },
          width: 350,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.ClientCode,
          field: 'analiseTecItemDetalhe.codigoCliente',
          width: 150,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Un.',
          field: 'analiseTecItemDetalhe.unidade',
          width: 70,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Quantity,
          field: 'analiseTecItemDetalhe.quantidade',
          valueGetter: params => params.data.tipoAgrupamento !== 1 && params.data.tipoAgrupamento !== 2 &&
            params.data.analiseTecItemDetalhe.quantidade !== 0 ? params.data.analiseTecItemDetalhe.quantidade : null,
          width: 50,
          type: 'numberColumn',
          cellEditorParams: {
            withNegative: true
          },
          menuTabs: ['filterMenuTab'],
          cellClass: param => {
            const originalValue = this.originalValues ? this.originalValues.filter(o => o.lpuItemID === param.data.lpuItemID)[0] : null
            const originalQtd = originalValue ? +originalValue.quantidade : 0
            const qtd = +param.data.analiseTecItemDetalhe.quantidade
            return (originalValue && originalQtd !== qtd) ? 'changed text-right' : 'text-right'
          },
          editable: param => param.data.tipoAgrupamento === 0 && this.statusEditable
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.UnitValue,
          field: 'analiseTecItemDetalhe.valor',
          valueGetter: params => params.data.tipoAgrupamento !== 1 && params.data.tipoAgrupamento !== 2 &&
            params.data.analiseTecItemDetalhe.quantidade !== 0 ? params.data.analiseTecItemDetalhe.valor : null,
          cellRendererParams: {
            maxDecimal: 2
          },
          width: 120,
          minWidth: 120,
          type: 'numberColumn',
          menuTabs: ['filterMenuTab'],
          editable: false
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.TotalValue,
          field: 'valorTotal',
          valueGetter: params => params.data.analiseTecItemDetalhe && params.data.tipoAgrupamento !== 1 && params.data.tipoAgrupamento !== 2 &&
            params.data.analiseTecItemDetalhe.quantidade !== 0 && params.data.analiseTecItemDetalhe.valor !== 0
            ? params.data.analiseTecItemDetalhe.quantidade * params.data.analiseTecItemDetalhe.valor : null,
          cellRendererParams: {
            maxDecimal: 2
          },
          width: 120,
          minWidth: 120,
          type: 'numberColumn',
          menuTabs: [],
          editable: false
        },
        {
          headerName: this.$lang.PCI.AT.LabelObservation,
          field: 'analiseTecItemDetalhe.observacao',
          width: 280,
          maxWidth: 1500,
          type: 'memoColumn',
          menuTabs: ['filterMenuTab'],
          cellEditorParams: {
            maxLength: 1000,
            cols: 50,
            rows: 15
          },
          editable: param => param.data.tipoAgrupamento === 0 && this.statusEditable
        }
      ],
      columnDefsTecAnalysis: [
        {
          headerName: 'ID Site',
          field: 'analiseTecCotacao.idSite',
          width: 120,
          minWidth: 60,
          hide: true,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'LPU',
          field: 'lpu',
          width: 500,
          minWidth: 70,
          valueGetter: param => {
            return `${param.data.lpu.descricao}/${param.data.lpu.regiao} - Rv.${param.data.lpu.revisao}`
          },
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Service,
          field: 'service',
          width: 200,
          minWidth: 70,
          valueGetter: param => {
            return param.data.servicoAnaliseTec
              ? param.data.servicoAnaliseTec.descricao + (this.serviceAnalysisTecNa.some(satna => satna.servicoAnaliseTecID === param.data.servicoAnaliseTecID && satna.status === 1)
                ? ' (N/A)'
                : '')
              : '<NULO>'
          },
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Revision,
          field: 'revisao',
          width: 60,
          minWidth: 50,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Elaboration,
          field: 'nomeContaAcao',
          width: 200,
          minWidth: 70,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Date,
          field: 'dataAcao',
          type: 'dateColumn',
          width: 120,
          minWidth: 60,
          valueFormatter: param => {
            return param.value ? new Date(param.value).toLocaleString() : ''
          },
          filterParams: {
            valueFormatter: param => {
              return param.value ? new Date(param.value).toLocaleString() : ''
            }
          },
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Status',
          field: 'statusAprovacao',
          type: 'atStatusColumn',
          width: 200,
          minWidth: 70,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.LabelObservation,
          field: 'analiseTecCotacao.observacao',
          hide: true,
          width: 200,
          minWidth: 70,
          menuTabs: ['filterMenuTab']
        }
      ],
      columnDefsQuotes: [
        {
          headerName: 'ID Site',
          field: 'analiseTecCotacao.idSite',
          flex: 30,
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'LPU',
          field: 'lpu',
          flex: 120,
          valueGetter: param => {
            return `${param.data.lpu.descricao}/${param.data.lpu.regiao}`
          },
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Service,
          field: 'service',
          flex: 40,
          valueGetter: param => {
            return param.data.servicoAnaliseTec
              ? param.data.servicoAnaliseTec.descricao + (this.serviceAnalysisTecNa.some(satna => satna.servicoAnaliseTecID === param.data.servicoAnaliseTecID && satna.status === 1)
                ? ' (N/A)'
                : '')
              : '<NULO>'
          },
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: this.$lang.PCI.AT.Datatable.Revision,
          field: 'revisao',
          flex: 20,
          menuTabs: ['filterMenuTab']
        }
      ]
    }
  },
  beforeMount () {
    this.itemRowClassRules = {
      'group-row': 'data.tipoAgrupamento === 1',
      'subgroup-row': 'data.tipoAgrupamento == 2'
    }
    this.atRowClassRules = {
      'revision-row': 'data.status !== 1'
    }
  },
  computed: {
    ...mapGetters('auth', ['userInfo']),
    statusPending () {
      return this.at && this.at.status && (this.at.statusAprovacao === this.statusApprove.PENDENTE || this.at.statusAprovacao === this.statusApprove.EM_DIGITACAO)
    },
    statusEditable () {
      return this.at && this.at.status && this.at.statusAprovacao !== this.statusApprove.APROVADA && !this.block.block &&
        (
          ((this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) || this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) || this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)) &&
            this.statusPending
          ) ||

          (this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) &&
            this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO
          ) ||

          (this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) &&
            this.at.statusAprovacao === this.statusApprove.EM_REV_ORCAMENTO
          )
        )
    },
    statusEditablePlanAndBudget () {
      return this.at && this.at.status && this.at.statusAprovacao !== this.statusApprove.APROVADA && !this.block.block &&
        (
          ((this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) || this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)) &&
            this.statusPending
          ) ||

          (this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) &&
            this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO
          ) ||

          (this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) &&
            this.at.statusAprovacao === this.statusApprove.EM_REV_ORCAMENTO
          )
        )
    },
    // Desmembrar cria AT nova por site: mesma barra de perfil do endpoint
    // (PERFIS_DESMEMBRA_AT no AnaliseTecController). Sem gate de status - AT aprovada
    // ja esta individual, e o lote pode divergir em qualquer ponto do fluxo.
    // sitesDaAt vem de at.obras, nao de works: works e resetado por onClearForm com os sites do
    // range do PCI (e obraID de dt.id), entao antes do GetByAnalysis voltar ele nao e a AT.
    sitesDaAt () {
      return (this.at && this.at.obras) || []
    },
    canDesmembrar () {
      return !!this.at && !!this.at.status && this.tecAnalysisType === this.tecAnalysisTypes.AT &&
        this.sitesDaAt.length > 1 && !this.block.block &&
        (
          this.hasRole(this.roles.RW_OPER_PCI_ADM) ||
          this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) ||
          this.hasRole(this.roles.RW_OPER_PCI_AT_LPU)
        )
    },
    // Pelo menos um site precisa ficar na AT de origem.
    desmembrarValido () {
      return this.sitesDesmembrar.length >= 1 && this.sitesDesmembrar.length < this.sitesDaAt.length
    },
    statusCancelablePlanAndBudget () {
      return this.at && this.at.status && this.tecAnalysisType === this.tecAnalysisTypes.AT && this.at.statusAprovacao !== this.statusApprove.CANCELADA && !this.block.block &&
        (
          this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) || this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)
        )
    },
    isReadOnly () {
      return (this.at && this.at.statusAprovacao === this.statusApprove.CANCELADA) ||
             (this.block.block) ||
             (!this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) &&
              !this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) &&
              !this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) &&
              !this.hasRole(this.roles.RW_OPER_PCI_AT_FINANC))
    },
    regionApprovable () {
      return this.at && this.at.status && this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) && !this.block.block &&
        (this.at.statusAprovacao === this.statusApprove.AG_APROV_REGIONAL_PLAN || this.at.statusAprovacao === this.statusApprove.AG_APROV_REGIONAL_ORC)
    },
    planRevising () {
      return this.at && this.at.status && this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO
    },
    budgetRevising () {
      return this.at && this.at.status && this.at.statusAprovacao === this.statusApprove.EM_REV_ORCAMENTO
    },
    planApprovable () {
      return this.at && this.at.status && !this.block.block &&
        (
          (
            this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) &&
            (this.at.statusAprovacao === this.statusApprove.AG_APROV_PLANEJAMENTO || this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO)
          ) ||
          (
            (this.hasRole(this.roles.RW_OPER_PCI_AT_DIRECTOR) || this.hasRole(this.roles.RW_OPER_PCI_AT_MANAGER)) &&
            (this.at.statusAprovacao === this.statusApprove.AG_APROV_PLANEJAMENTO || this.at.statusAprovacao === this.statusApprove.AG_APROV_ORCAMENTO)
          )
        )
    },
    budgetApprovable () {
      return this.at && this.at.status && this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) && !this.block.block &&
          (this.at.statusAprovacao === this.statusApprove.AG_APROV_ORCAMENTO || this.at.statusAprovacao === this.statusApprove.EM_REV_ORCAMENTO)
    },
    getLabelPlanApprove () {
      if (this.hasRole(this.roles.RW_OPER_PCI_AT_DIRECTOR)) {
        return this.$lang.PCI.AT.LabelDirector
      }
      if (this.hasRole(this.roles.RW_OPER_PCI_AT_MANAGER)) {
        return this.$lang.PCI.AT.LabelManager
      }
      return this.$lang.PCI.AT.LabelPlan
    },
    additiveColumns () {
      const cols = []
      cols.push(this.$lang.PCI.AT.Datatable.Item)
      cols.push(this.$lang.PCI.AT.Datatable.Description)
      cols.push('Un.')
      cols.push(this.$lang.PCI.AT.Datatable.Quantity)
      cols.push(this.$lang.PCI.AT.Datatable.UnitValue)
      cols.push(this.$lang.PCI.AT.Datatable.TotalValue)
      if (this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)) {
        cols.push(this.$lang.Common.DataTable.Actions)
      }
      return cols
    },
    tecAnalysisItemsSum () {
      const result = this.tecAnalysisItemsSumNumber

      return result.toLocaleString('pt-br', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    tecAnalysisItemsCalculatedSum () {
      if (!this.at) return ''

      const result = this.tecAnalysisItemsSumNumber * this.at.fatorImposto * this.at.fatorMoeda * this.at.fatorRegiao

      return result.toLocaleString('pt-br', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    tecAnalysisItemsSumNumber () {
      const func = (ac, atual) => {
        if (atual.analiseTecItemDetalhe) {
          return ac + ((atual.analiseTecItemDetalhe.quantidade || 0) * (atual.analiseTecItemDetalhe.valor || 0))
        }
        return ac
      }

      const totalItems = this.tecAnalysisItems.reduce(func, 0)
      const totalExtras = this.extraItems.reduce(func, 0)
      const total = totalItems + totalExtras
      const result = (Math.round((total + Number.EPSILON) * 100) / 100)

      return result
    },
    concatObservation () {
      const obs = this.at.observacoes
        ? this.at.observacoes.reduce((obs, current) => {
          const pre = obs === '' ? '' : '\n\n'
          obs += (pre + current.observacao)
          return obs
        }, '')
        : null

      return obs
    }
  },
  methods: {
    onLoad () {
      this.viewLog = false
      this.viewLogRes = false
      if (this.pci.pciId) {
        loading.push()
        ServiceAnalysisTecNaRepository.GetAllByWork(this.pci.obraId)
          .then(response => {
            if (response.data.code > 0) {
              this.serviceAnalysisTecNa = response.data.data
            }
          })
          .then(() => {
            this.onLoadAT()
          })

        ServiceAnalysisTecRepository.GetAllByPci(this.pci.pciId)
          .then(response => {
            if (response.data.code > 0) {
              this.serviceAnalysisTecList = response.data.data
            }
          })
          .catch(err => console.log(err))

        LpuPciRepository.GetAllByPci(this.pci.pciId)
          .then(respLpuPci => {
            if (respLpuPci.data.code > 0) {
              this.objListLpu = respLpuPci.data.data.map(dt => {
                return {
                  value: dt.id,
                  text: `${dt.lpu.descricao}/${dt.lpu.regiao}`,
                  object: dt
                }
              })
            }
          })
          .finally(() => loading.close())
      }
    },
    onLoadAT () {
      if (this.tecAnalysisType === tecAnalysisTypes.AT) {
        return TecAnalysisRepository.GetAllByWork(this.pcis.map(p => p.obraId))
          .then(response => {
            if (response.data.code > 0) {
              this.objListAll = response.data.data
              this.processList()
            }
          })
      } else {
        return TecAnalysisRepository.GetAllQuoteByContract({params: {contratoID: this.pci.idContrato}})
          .then(response => {
            if (response.data.code > 0) {
              this.objListAll = response.data.data
              this.processList()
            }
          })
      }
    },
    onChangeAT () {
      this.viewLog = false
      this.viewLogRes = false

      this.$nextTick(() => {
        this.at.servicoAnaliseTecID = this.serviceAnalysisTecSelected
        this.at.sla = isNaN(parseInt(this.at.sla)) ? 0 : parseInt(this.at.sla)

        loading.push()
        TecAnalysisRepository.Update(false, this.at)
          .then(response => {
            if (response.data.code <= 0) {
              toast.error(response.data.message)
            }
            this.onSelect()
            this.onLoadAT()
          })
          .catch(err => {
            console.log(err)
          }).finally(() => {
            loading.close()
          })
      })
    },
    onRemoveWork (work) {
      if (this.works.length > 0) {
        this.createBoxConfirm(this.$lang.PCI.AT.ConfirmRemoveSite)
          .then(value => {
            if (!value) {
              this.works.push(work)
            } else {
              this.at.obras = this.at.obras.filter(ob => ob.obraID !== work.obraID)
              this.onChangeAT()
            }
          })
      } else {
        this.works.push(work)
      }
    },
    show (data, type = tecAnalysisTypes.AT) {
      this.tecAnalysisType = type
      this.pci = data[0]
      this.pcis = data
      this.lpuPciID = null
      this.at = null
      this.onClearForm()
      this.onLoad()
      this.$nextTick(() => {
        this.$refs['tecAnalysisModal'].show()

        this.$nextTick(() => {
          this.gridPopupParent = document.querySelector('.modal-body')
          document.getElementById('tecAnalysisModal')
            .addEventListener('keydown', (evt) => {
              if (evt.key === 'Enter' && this.editing) {
                evt.stopPropagation()
                evt.preventDefault()
                const currentCell = this.gridOptionsTecAnalysisItems.api.getFocusedCell()
                const finalRowIndex = this.gridOptionsTecAnalysisItems.api.rowModel.getRowCount() - 1

                let qt = 1
                while (true) {
                  if ((currentCell.rowIndex + qt) >= finalRowIndex) {
                    break
                  }
                  const row = this.gridOptionsTecAnalysisItems.api.rowModel.getRow(currentCell.rowIndex + qt)
                  if (row.data.tipoAgrupamento !== 0) {
                    qt += 1
                  } else {
                    break
                  }
                }

                if (currentCell.rowIndex === finalRowIndex) {
                  return
                }

                this.gridOptionsTecAnalysisItems.api.clearFocusedCell()
                this.gridOptionsTecAnalysisItems.api.startEditingCell({
                  rowIndex: currentCell.rowIndex + qt,
                  colKey: currentCell.column.colId
                })
              }
              if (evt.key === 'Escape' && !this.editing) {
                evt.stopPropagation()
                evt.preventDefault()
                this.onClose(evt)
              }
            })
        })
      })
    },
    getRowItemStyle (params) {
      if (params.data.lpuItem && params.data.lpuItem.cor) {
        const lpuItem = params.data.lpuItem
        return {'background-color': lpuItem.cor, 'font-weight': lpuItem.negrito ? 'bold' : 'normal', 'color': lpuItem.fonteClara ? '#ffffff' : '#000000'}
      }
      return null
    },
    onClose (event) {
      if (this.newObservation) {
        event.preventDefault()
        this.$bvModal.msgBoxOk('Não é possivel abandonar a AT sem salvar a observação!')
      } else {
        this.onClearForm()
        this.$refs['tecAnalysisModal'].hide()
        this.$emit('Hide')
      }
    },
    onGridReady (params) {
      this.$nextTick(() => {
        const colSite = params.columnApi.getColumn('analiseTecCotacao.idSite')
        const colObs = params.columnApi.getColumn('analiseTecCotacao.observacao')
        params.columnApi.setColumnsVisible([colSite, colObs], this.tecAnalysisType === tecAnalysisTypes.Quote)
        params.api.sizeColumnsToFit()
        this.onLoadLayout()
      })
    },
    onGridReadyItems (params) {
      this.$nextTick(() => {
        params.api.sizeColumnsToFit()
      })
    },
    onShowAllColumns () {
      loading.push()
      const columnApi = this.gridOptionsTecAnalysisItems.columnApi
      setTimeout(() => {
        columnApi.setColumnsVisible(columnApi.getColumns(), true)
        this.$nextTick(() => {
          this.gridOptionsTecAnalysisItems.api.sizeColumnsToFit()
        })
        loading.close()
      }, 100)
    },
    onSaveLayout () {
      loading.push()
      PCILayoutContaRepository.CreateAt({
        PCIID: this.pci.pciId,
        LayoutAt: JSON.stringify(this.gridOptionsTecAnalysisItems.columnApi.getColumnState())
      })
        .catch(err => console.log(err))
        .finally(() => loading.close())
    },
    onLoadLayout () {
      PCILayoutContaRepository.Get(this.pci.pciId)
        .then(response => {
          if (response.data.code > 0 && response.data.data.layoutAt) {
            const layout = JSON.parse(response.data.data.layoutAt)
            this.gridOptionsTecAnalysisItems.columnApi.applyColumnState({ state: layout, applyOrder: false })
          }
        })
        .catch(err => console.log(err))
    },
    onNewTecAnalysis () {
      const lpuPci = this.objListLpu.filter(l => l.value === this.lpuPciID)[0].object
      const newObj = {
        id: '00000000-0000-0000-0000-000000000000',
        lpuID: lpuPci.lpuID,
        pciModeloItemID: lpuPci.pciModeloItemID,
        // obraID: this.pci.obraId,
        obras: this.tecAnalysisType === tecAnalysisTypes.AT ? this.pcis.map(p => {
          return {
            id: '00000000-0000-0000-0000-000000000000',
            analiseTecID: '00000000-0000-0000-0000-000000000000',
            obraID: p.obraId
          }
        }) : [],
        analiseTecCotacao: this.tecAnalysisType === tecAnalysisTypes.Quote ? {
          id: '00000000-0000-0000-0000-000000000000',
          analiseTecID: '00000000-0000-0000-0000-000000000000',
          contratoID: this.pci.idContrato,
          idSite: ''
        } : null,
        statusAprovacao: this.statusApprove.EM_DIGITACAO,
        revisao: 0,
        observacao: ''
      }

      loading.push()
      TecAnalysisRepository.Create(newObj)
        .then(response => {
          if (response.data.code > 0) {
            this.at = {...response.data.data}
            this.$emit('Update', this.at.obras)
            this.at.lpu = lpuPci.lpu
            this.at.pciModeloItem = lpuPci.pciModeloItem
            this.at.revisao = 0
            this.objList.push(this.at)
            this.at.dataAcao = Tools.FormatDate(this.at.dataAcao)

            this.originalValues = this.at.itens
              .map(v => {
                return {
                  analiseTecItemID: v.id,
                  ordem: v.ordem,
                  quantidade: v.analiseTecItemDetalhe.quantidade
                }
              })

            this.tecAnalysisItemsOrig = this.at.itens.filter(it => it.origemItem === 0)
            this.processItems()
            this.lpuPciID = null
            this.$nextTick(() => {
              this.gridOptionsTecAnalysis.api.getRowNode(this.at.id).setSelected(true)
            })
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .finally(() => loading.close())
        .catch(err => this.onException(err))
    },
    onChangeLpu () {
      this.createBoxConfirm(this.$lang.PCI.AT.WarningChangeLpu)
        .then(value => {
          if (value) {
            const lpuPci = this.objListLpu.filter(l => l.value === this.lpuToChangeID)[0].object
            const newObj = {
              id: this.at.id,
              lpuID: lpuPci.lpuID,
              pciModeloItemID: lpuPci.pciModeloItemID,
              // obraID: this.pci.obraId,
              obras: this.pcis.map(p => {
                return {
                  id: '00000000-0000-0000-0000-000000000000',
                  analiseTecID: this.at.id,
                  obraID: p.obraId
                }
              }),
              statusAprovacao: this.statusApprove.EM_DIGITACAO,
              revisao: this.at.revisao,
              observacao: ''
            }

            loading.push()
            this.gridOptionsTecAnalysis.api.getRowNode(this.at.id).setSelected(false)
            TecAnalysisRepository.ChangeLpu(newObj)
              .then(response => {
                if (response.data.code > 0) {
                  this.at = {...response.data.data}
                  this.$emit('Update', this.at.obras)
                  this.at.lpu = lpuPci.lpu
                  this.at.pciModeloItem = lpuPci.pciModeloItem
                  this.at.serviceAnalysisTec = this.at.serviceAnalysisTec

                  this.originalValues = this.at.itens
                    .map(v => {
                      return {
                        analiseTecItemID: v.id,
                        ordem: v.ordem,
                        quantidade: v.analiseTecItemDetalhe.quantidade
                      }
                    })

                  this.tecAnalysisItemsOrig = this.at.itens.filter(it => it.origemItem === 0)
                  this.processItems()
                  this.lpuPciID = null
                  this.$nextTick(() => {
                    response.data.data.servicoAnaliseTec = this.gridOptionsTecAnalysis.api.getRowNode(this.at.id).data.servicoAnaliseTec
                    this.gridOptionsTecAnalysis.api.applyTransaction({ update: [response.data.data] })
                    this.gridOptionsTecAnalysis.api.getRowNode(this.at.id).setSelected(true)
                  })
                } else {
                  toast.error(this.$lang.Common.CouldNotSave)
                }
              })
              .finally(() => loading.close())
              .catch(err => this.onException(err))
          }
          this.lpuToChangeID = null
        })
    },
    onShowQuotesToImport () {
      this.$refs.quotesModal.show()
      loading.push()
      TecAnalysisRepository.GetAllQuoteByContract({params: {contratoID: this.pci.idContrato}})
        .then(response => {
          if (response.data.code > 0) {
            this.objListQuotesToImport = response.data.data.filter(q => q.statusAprovacao === this.statusApprove.APROVADA)
            this.$nextTick(() => {
              this.gridOptionsQuotes.api.sizeColumnsToFit()
            })
          }
        })
        .finally(() => loading.close())
    },
    onSelectQuoteToImport (evt) {
      if (this.gridOptionsQuotes.api.getSelectedRows().length === 0) {
        toast.warning(this.$lang.Common.ClickToSelect)
        evt.preventDefault()
        return
      }
      const quote = this.gridOptionsQuotes.api.getSelectedRows()[0]
      quote.obras = this.pcis.map(p => {
        return {
          id: '00000000-0000-0000-0000-000000000000',
          analiseTecID: '00000000-0000-0000-0000-000000000000',
          obraID: p.obraId
        }
      })
      if (this.objList.some(a => a.lpuID === quote.lpuID && a.servicoAnaliseTecID === quote.servicoAnaliseTecID && a.statusAprovacao === this.statusApprove.APROVADA)) {
        this.createBoxConfirm(this.$lang.PCI.AT.ConfirmImportQuote)
          .then(valor => {
            if (valor) {
              this.importQuote(quote)
                .catch(err => {
                  console.log(err)
                  evt.preventDefault()
                  toast.error(this.$lang.Common.Alerts.Error)
                })
            }
          })
      } else {
        this.importQuote(quote)
          .catch(err => {
            console.log(err)
            evt.preventDefault()
            toast.error(this.$lang.Common.Alerts.Error)
          })
      }
    },
    importQuote (obj) {
      loading.push()
      return TecAnalysisRepository.ImportQuote(obj)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onLoadAT()
            this.$emit('Update', obj.obras)
          } else {
            throw new Error(response.data.message)
          }
        })
        .finally(() => loading.close())
    },
    processList () {
      this.objList = this.objListAll.filter(l => this.showRevisions || l.status)
    },
    processItems () {
      this.tecAnalysisItems = this.tecAnalysisItemsOrig.filter(i => {
        var result = true
        if (this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) ||
          this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) ||
          this.hasRole(this.roles.R_OPER_PCI_AT_READ)) {
          if (!this.showAll) {
            result = i.analiseTecItemDetalhe.quantidade !== 0
          }
        }
        return result
      })
    },
    onExportExcel () {
      loading.push()
      TecAnalysisRepository.ExportExcel(this.at.id)
        .then(response => {
          if (response.data.code > 0) {
            const data = Uint8Array.from(atob(response.data.data.file), c => c.charCodeAt(0))
            const blob = new Blob([data], {type: response.data.data.contentType})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.data.data.name
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    viewTecLog (back) {
      loading.push()
      TecAnalysisRepository.GetLog(this.at.id)
        .then(response => {
          this.logTec = []
          this.logTecRes = []
          const ultDig = moment(response.data.data.find(d => d.statusAprovacao === 5).dataAcao)
          response.data.data.forEach(i => {
            this.logTec.push({
              id: i.id,
              nomeContaAcao: i.nomeContaAcao,
              dataAcaoFormatada: i.dataAcaoFormatada,
              descricao: this.$lang.PCI.AT['Status' + i.statusAprovacao]
            })
            const dtDig = moment(i.dataAcao)
            if (dtDig >= ultDig && i.statusAprovacao !== 5) {
              const hasRegPlan = response.data.data.findIndex(d => moment(d.dataAcao) >= ultDig && (d.statusAprovacao === 16)) !== -1
              const hasRegOrc = response.data.data.findIndex(d => moment(d.dataAcao) >= ultDig && (d.statusAprovacao === 18)) !== -1
              // const ativ = i.statusAprovacao === 20
              //   ? 'AT EXECUTADA'
              //   : (i.statusAprovacao === 22 && !hasRegPlan) || i.statusAprovacao === 16
              //     ? 'AT APROVADA'
              //     : (i.statusAprovacao === 50 && !hasRegOrc) || i.statusAprovacao === 18
              //       ? 'MEDIÇÃO'
              //       : i.statusAprovacao === 1 || i.statusAprovacao === 2
              //         ? 'AT REPROVADA'
              //         : 'N/A'

              const ativ = i.statusAprovacao === 20
                ? 'AT EXECUTADA'
                : (i.statusAprovacao === 22 && !hasRegPlan) || i.statusAprovacao === 16
                  ? 'AT APROVADA'
                  : (i.statusAprovacao === 50 && !hasRegOrc) || i.statusAprovacao === 18
                    ? 'MEDIÇÃO'
                    : i.statusAprovacao === 1 || i.statusAprovacao === 2
                      ? 'AT REPROVADA'
                      : i.statusAprovacao === 60
                        ? 'CANCELADA'
                        : 'N/A'

              const func = i.statusAprovacao === 20
                ? 'COORDENADOR'
                : (((i.statusAprovacao === 22 && !hasRegPlan) || i.statusAprovacao === 16) || i.statusAprovacao === 1) && i.perfis.includes('RW_OPER_PCI_AT_DIRECTOR')
                  ? 'DIRETOR TÉCNICO'
                  : (((i.statusAprovacao === 22 && !hasRegPlan) || i.statusAprovacao === 16) || i.statusAprovacao === 1) && i.perfis.includes('RW_OPER_PCI_AT_MANAGER')
                    ? 'GERENTE COORD'
                    : (((i.statusAprovacao === 22 && !hasRegPlan) || i.statusAprovacao === 16) || i.statusAprovacao === 1)
                      ? 'PLANEJAMENTO'
                      : ((i.statusAprovacao === 50 && !hasRegOrc) || i.statusAprovacao === 18) || i.statusAprovacao === 2
                        ? 'ORÇAMENTO'
                        : i.statusAprovacao === 60
                          ? ''
                          : 'N/A'

              const idx = this.logTecRes.findIndex(l => l.atividade === ativ && l.funcao === func)
              if (idx === -1 && func !== 'N/A' && ativ !== 'N/A') {
                this.logTecRes.push({
                  funcao: func,
                  nome: i.nomeContaAcao,
                  atividade: ativ,
                  data: i.dataAcaoFormatada
                })
              }
            }
          })
        })
        .finally(() => {
          loading.close()
          this.viewLog = this.viewLogRes && !back
          this.viewLogRes = !this.viewLogRes
        })
    },
    onRowSelect (event) {
      const selecionada = event.api.getSelectedRows()[0]

      // selectionChanged dispara tambem quando a selecao fica vazia (ctrl+click na
      // linha, deselectAll). Sem esta guarda, this.at virava {} e o onSelect buscava
      // AT com id undefined.
      if (!selecionada) {
        this.at = null
        this.onClearForm()
        return
      }

      this.onClearForm()
      this.at = {...selecionada}
      this.onSelect()
    },
    onOpenDesmembrar () {
      this.sitesDesmembrar = []
      this.$refs.desmembraModal.show()
    },
    onDesmembrar () {
      if (!this.at || !this.desmembrarValido) {
        toast.warning(this.sitesDesmembrar.length === 0
          ? this.$lang.PCI.AT.WarningDesmembrarVazio
          : this.$lang.PCI.AT.WarningDesmembrarTodos)
        return
      }

      loading.push()
      const analiseTecID = this.at.id
      TecAnalysisRepository.Desmembrar(analiseTecID, this.sitesDesmembrar)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('Update', this.at.obras)
            this.sitesDesmembrar = []
            // A AT-mae continua existindo (com os sites que ficaram), diferente do
            // onDeleteAT/onCancelAT: mantem a LPU e reabre a AT em vez de limpar a tela.
            return this.onLoadAT().then(() => this.reabrirAT(analiseTecID))
          } else {
            toast.error(response.data.message || this.$lang.Common.CouldNotSave)
          }
        })
        .finally(() => loading.close())
        .catch(err => this.onException(err))
    },
    // Reabre a AT no grid como se o usuario tivesse clicado na linha. deselectAll antes
    // porque o getRowId preserva a selecao no reload, e setSelected numa linha que JA
    // esta selecionada nao dispara selectionChanged.
    reabrirAT (analiseTecID) {
      const api = this.gridOptionsTecAnalysis.api
      if (!api) return

      let node = null
      api.forEachNode(n => {
        if (n.data && n.data.id === analiseTecID) node = n
      })

      api.deselectAll()

      // AT fora da lista (filtro de revisoes, por ex.): o deselectAll ja limpou a tela.
      if (node) node.setSelected(true)
    },
    onDeleteAT () {
      if (!this.at) {
        return
      }

      this.createBoxConfirm(this.$lang.Common.ConfirmDelete)
        .then(value => {
          if (value) {
            loading.push()
            TecAnalysisRepository.Delete(this.at.id)
              .then(response => {
                if (response.data.code > 0) {
                  this.lpuPciID = null
                  this.$emit('Update', this.at.obras)
                  this.at = null
                  this.onClearForm()
                  this.onLoadAT()
                } else {
                  toast.error(this.$lang.Common.CouldNotSave)
                }
              })
              .finally(() => loading.close())
              .catch(err => this.onException(err))
          }
        })
    },
    onCancelAT () {
      if (!this.at) {
        return
      }

      this.createBoxConfirm(this.$lang.Common.ConfirmCancel)
        .then(value => {
          if (value) {
            loading.push()
            TecAnalysisRepository.Cancel(this.at.id)
              .then(response => {
                if (response.data.code > 0) {
                  this.lpuPciID = null
                  this.$emit('Update', this.at.obras)
                  this.at = null
                  this.onClearForm()
                  this.onLoadAT()
                } else {
                  toast.error(this.$lang.Common.CouldNotSave)
                }
              })
              .finally(() => loading.close())
              .catch(err => this.onException(err))
          }
        })
    },
    onSelect () {
      loading.push()
      this.onClearForm()
      if (!this.at) {
        loading.close()
        return
      }
      this.viewLog = false
      this.viewLogRes = false
      TecAnalysisDetailItemRepository.GetLastHistoric(this.at.id)
        .then(response => {
          if (response.data.code > 0) {
            this.originalValues = response.data.data

            TecAnalysisRepository.GetByAnalysis(this.at.id)
              .then(response => {
                if (response && response.data.code > 0) {
                  this.at = {...response.data.data}
                  this.works = this.at.obras.map(ob => {
                    return {
                      obraID: ob.obraID,
                      referencia: ob.obra.referencia,
                      idSite: ob.obra.idSite
                    }
                  })

                  this.at.dataAcao = Tools.FormatDate(this.at.dataAcao)
                  this.tecAnalysisItemsOrig = this.at.itens.filter(it => it.origemItem === 0)
                  this.extraItems = this.at.itens.filter(it => it.origemItem !== 0)
                  this.serviceAnalysisTecSelected = this.at.servicoAnaliseTecID
                  const serviceList = this.serviceAnalysisTecList
                  this.processItems()
                  this.serviceAnalysisTec = serviceList.map(sv => {
                    return {
                      value: sv.id,
                      text: sv.descricao + (this.serviceAnalysisTecNa.some(satna => satna.servicoAnaliseTecID === sv.id && satna.status === 1) ? ' (N/A)' : '')
                    }
                  })
                  this.objListLpuToChange = this.objListLpu.filter(l => l.object.lpuID !== this.at.lpuID)
                }
              })
              .then(() => {
                this.$nextTick(() => {
                  const grid = this.$refs.gridItems.$el
                  const div = grid.getElementsByClassName('ag-body-viewport')[0]
                  if (div.clientHeight < div.scrollHeight) {
                    const self = this
                    div.addEventListener('scroll', event => {
                      const top = Math.round(div.scrollTop + div.clientHeight)
                      const height = div.scrollHeight
                      self.scrollAllItems = self.scrollAllItems || Math.abs(top - height) <= 10
                    })
                  } else {
                    this.scrollAllItems = true
                  }
                  if (this.tecAnalysisType === tecAnalysisTypes.AT) {
                    this.ACCheckIn('analisetec', this.at.id)
                      .then(response => {
                        this.block = response
                      })
                  } else {
                    this.ACCheckIn('analiseteccotacao', this.at.id)
                      .then(response => {
                        this.block = response
                      })
                  }
                })
              })
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onClearForm () {
      this.ACCheckOut()
      this.editingObs = null
      this.block = {}
      this.tecAnalysisItems = []
      this.extraItems = []
      this.works = this.pcis.map(dt => {
        return {
          obraID: dt.id,
          referencia: dt.referencia,
          idSite: dt.idSite
        }
      })
      this.obsReject = ''
      this.newObservation = ''
      this.moneyFactor = 1
      this.regionFactor = 1
      this.taxesFactor = 1
      this.additive = null
      this.serviceAnalysisTecSelected = null
    },
    onChange (event) {
      if (event.column.userProvidedColDef.headerName === 'Qt.') {
        event.data.analiseTecItemDetalhe.quantidadeAlterada = true
      }

      event.data.analiseTecItemDetalhe.quantidade = !event.data.analiseTecItemDetalhe.quantidade ? 0 : event.data.analiseTecItemDetalhe.quantidade
      TecAnalysisDetailItemRepository.Update(event.data.analiseTecItemDetalhe)
        .then(response => {
          if (response.data.code > 0) {
          } else {
            toast.error(this.$lang.Common.Alerts.CouldNotSave)

            event.node.data[event.colDef.field] = event.oldValue
          }
          // event.api.refreshCells()
        })
        .catch(err => {
          this.onException(err)
          event.node.data[event.colDef.field] = event.oldValue
          event.api.refreshCells()
        })
    },
    onFinalize () {
      if (!this.serviceAnalysisTecSelected) {
        this.$refs.selectTypeAT.focus()
        toast.warning(this.$lang.PCI.AT.WarningServiceNotSelected)
        return
      }
      this.createBoxConfirm(this.$lang.PCI.AT.ConfirmToPlan)
        .then(value => {
          if (value) {
            loading.push()

            if (this.newObservation) {
              this.at.observacoes.push({
                analiseTecID: this.at.id,
                id: empty(),
                observacao: this.newObservation,
                status: 1
              })
            }
            this.at.observacoes.push({
              analiseTecID: this.at.id,
              id: empty(),
              observacao: `${new Date().toLocaleString()}: Finalizada por ${this.userInfo.nome}`,
              status: 1
            })
            this.obsReject = ''
            this.newObservation = ''
            this.moneyFactor = 1
            this.regionFactor = 1
            this.taxesFactor = 1
            this.at.obsRejeicao = ''
            this.at.statusAprovacao = this.statusApprove.AG_APROV_PLANEJAMENTO

            this.onUpdate()
              .finally(() => loading.close())
          }
        })
    },
    onRevisionFinalize () {
      this.createBoxConfirm(this.$lang.PCI.AT.ConfirmToRegion)
        .then(value => {
          if (value) {
            loading.push()
            this.newObservation = `${new Date().toLocaleString()}: Finalizada por ${this.userInfo.nome}`
            this.at.obsRejeicao = ''
            this.at.statusAprovacao = this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO ? this.statusApprove.AG_APROV_REGIONAL_PLAN : this.statusApprove.AG_APROV_REGIONAL_ORC

            this.onUpdate()
              .finally(() => loading.close())
          }
        })
    },
    onRevisionAbort () {
      this.createBoxConfirm(this.$lang.PCI.AT.ConfirmAbort)
        .then(value => {
          if (value) {
            const itemsOrig = cloneDeep(this.originalValues)
            this.at.statusAprovacao = this.at.statusAprovacao === this.statusApprove.EM_REV_PLANEJAMENTO ? this.statusApprove.AG_APROV_PLANEJAMENTO : this.statusApprove.AG_APROV_ORCAMENTO
            this.newObservation += `${new Date().toLocaleString()}: Revisão abortada por ${this.userInfo.nome}`
            this.at.revisao -= 1
            this.clone = false

            const promises = [Promise.resolve()]
            this.tecAnalysisItems.forEach(it => {
              if (it.origemItem === 0) {
                const itOrig = itemsOrig.filter(o => o.lpuItemID === it.lpuItemID)[0]
                if (it.analiseTecItemDetalhe.quantidade !== itOrig.quantidade || it.analiseTecItemDetalhe.observacao !== itOrig.observacao) {
                  it.analiseTecItemDetalhe.quantidade = itOrig.quantidade
                  it.analiseTecItemDetalhe.observacao = itOrig.observacao

                  promises.push(TecAnalysisDetailItemRepository.Update(it.analiseTecItemDetalhe))
                }
              }
            })

            Promise.all(promises)
              .then(() => {
                this.onUpdate()
                  .then(() => {
                  })
                  .finally(() => this.onSelect())
              })
          }
        })
    },
    onReview () {
      this.createBoxConfirm(this.$lang.Common.ConfirmReview, false, 'REVIEW')
        .then(value => {
          if (value) {
            loading.push()
            this.at.statusAprovacao = this.statusApprove.EM_DIGITACAO
            this.at.revisao += 1
            this.clone = true
            this.newObservation += `${new Date().toLocaleString()}: Revisado por ${this.userInfo.nome} \nMotivo: ${this.obsReview}`
            this.onUpdate()
              .finally(() => {
                this.obsReview = ''
                loading.close()
              })
          }
        })
    },
    onReviewPlan () {
      this.createBoxConfirm(this.$lang.Common.ConfirmReview, false, 'REVIEW')
        .then(value => {
          if (value) {
            loading.push()
            this.at.statusAprovacao = this.statusApprove.EM_REV_PLANEJAMENTO
            this.at.revisao += 1
            this.clone = true
            this.newObservation = `${new Date().toLocaleString()}: Revisado por ${this.userInfo.nome} \nMotivo: ${this.obsReview}`
            this.onUpdate()
              .finally(() => {
                this.obsReview = ''
                loading.close()
              })
          }
        })
    },
    onReviewBudget () {
      this.createBoxConfirm(this.$lang.Common.ConfirmReview, false, 'REVIEW')
        .then(value => {
          if (value) {
            loading.push()
            this.at.statusAprovacao = this.statusApprove.EM_REV_ORCAMENTO
            this.at.revisao += 1
            this.clone = true
            this.newObservation = `${new Date().toLocaleString()}: Revisado por ${this.userInfo.nome} \nMotivo: ${this.obsReview}`
            this.onUpdate()
              .finally(() => {
                this.obsReview = ''
                loading.close()
              })
          }
        })
    },
    createBoxConfirm (title, approve = true, type = null) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])
      if (!approve && type !== 'REVIEW') {
        messageVNode.children.push(
          h('h6', [
            h('strong', [
              this.$lang.Common.LabelRejectReason
            ])
          ]),
          h('b-textarea', {
            props: { value: this.obsReject },
            on: { input: (value) => {
              this.obsReject = value
            }}
          })
        )
      } else if (!approve && type === 'REVIEW') {
        messageVNode.children.push(
          h('h6', [
            h('strong', [
              this.$lang.Common.LabelReason
            ])
          ]),
          h('b-textarea', {
            props: { value: this.obsReview },
            on: { input: (value) => {
              this.obsReview = value
            }}
          })
        )
      } else if (type === 'BUDGET') {
        messageVNode.children.push(
          h('h6', [
            h('strong', [
              this.$lang.PCI.AT.LabelMoneyFactor
            ])
          ]),
          h('b-input', {
            props: { type: 'number', min: '1', value: this.at.fatorMoeda },
            class: 'mb-3',
            on: { input: (value) => {
              this.at.fatorMoeda = value
              document.getElementById('modal-budget-total').value = this.tecAnalysisItemsCalculatedSum
            } }
          }),
          h('h6', [
            h('strong', [
              this.$lang.PCI.AT.LabelRegionFactor
            ])
          ]),
          h('b-input', {
            props: { type: 'number', min: '1', value: this.at.fatorRegiao },
            class: 'mb-3',
            on: { input: (value) => {
              this.at.fatorRegiao = value
              document.getElementById('modal-budget-total').value = this.tecAnalysisItemsCalculatedSum
            } }
          }),
          h('h6', [
            h('strong', [
              this.$lang.PCI.AT.LabelTaxesFactor
            ])
          ]),
          h('b-input', {
            props: { type: 'number', min: '1', value: this.at.fatorImposto },
            class: 'mb-3',
            on: { input: (value) => {
              this.at.fatorImposto = value
              document.getElementById('modal-budget-total').value = this.tecAnalysisItemsCalculatedSum
            } }
          }),
          h('h6', [
            h('strong', [
              this.$lang.PCI.AT.LabelTotalValue
            ])
          ]),
          h('b-input', {
            props: { id: 'modal-budget-total', type: 'text', disabled: true, value: this.tecAnalysisItemsCalculatedSum },
            class: 'text-right'
          })
        )
      }

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: title,
        centered: true,
        okTitle: this.$lang.Yes,
        cancelTitle: this.$lang.No,
        headerClass: 'justify-content-center'
      })
    },
    onRegionApprove () {
      const statusAprovacao = this.at.statusAprovacao
      const obsRejeicao = this.at.obsRejeicao
      this.approving = true
      this.obsReject = ''

      let hasChange = false
      this.tecAnalysisItems.forEach(obj => {
        const originalValue = this.originalValues ? this.originalValues.filter(o => o.analiseTecItemID === obj.id)[0] : null
        const originalQtd = originalValue ? +originalValue.quantidade : 0
        const qtd = +obj.analiseTecItemDetalhe.quantidade
        hasChange = hasChange || (Boolean(originalValue) && originalQtd !== qtd)
      })
      let title = ''
      if (hasChange) {
        title = this.at.statusAprovacao === this.statusApprove.AG_APROV_REGIONAL_PLAN ? this.$lang.PCI.AT.ConfirmToPlan : this.$lang.Common.ConfirmToBudget
      } else {
        title = this.at.statusAprovacao === this.statusApprove.AG_APROV_REGIONAL_PLAN ? this.$lang.PCI.AT.ConfirmToBudget : this.$lang.Common.ConfirmFinish
      }

      this.createBoxConfirm(title)
        .then(value => {
          if (value) {
            loading.push()
            this.at.obsRejeicao = this.obsReject
            this.at.statusAprovacao = this.at.statusAprovacao === this.statusApprove.AG_APROV_REGIONAL_PLAN ? this.statusApprove.AG_APROV_ORCAMENTO : this.statusApprove.APROVADA

            this.onUpdate()
              .catch(err => {
                console.log(err)
                this.at.statusAprovacao = statusAprovacao
                this.at.obsRejeicao = obsRejeicao
                this.onException(err)
              })
              .finally(() => loading.close())
          }
        })
    },
    onPlanningApprove (approve) {
      const statusAprovacao = this.at.statusAprovacao
      const obsRejeicao = this.at.obsRejeicao
      this.approving = approve
      this.obsReject = ''
      this.createBoxConfirm(approve ? this.$lang.PCI.AT.ConfirmToBudget : this.$lang.Common.ConfirmReject, approve)
        .then(value => {
          if (value) {
            loading.push()

            this.at.obsRejeicao = this.obsReject
            this.at.statusAprovacao = approve ? this.statusApprove.AG_APROV_ORCAMENTO : this.statusApprove.REJEITADO_PLANEJAMENTO
            this.newObservation += approve ? `${new Date().toLocaleString()}: Aprovado pelo ${this.getLabelPlanApprove} por ${this.userInfo.nome}` : `${new Date().toLocaleString()}: Rejeitado pelo ${this.getLabelPlanApprove} por ${this.userInfo.nome}\nMotivo: ${this.obsReject}`

            this.onUpdate()
              .catch(err => {
                console.log(err)
                this.at.statusAprovacao = statusAprovacao
                this.at.obsRejeicao = obsRejeicao
                this.onException(err)
              })
              .finally(() => loading.close())
          }
        })
    },
    onBudgetApprove (approve) {
      const statusAprovacao = this.at.statusAprovacao
      const obsRejeicao = this.at.obsRejeicao
      this.approving = approve
      this.obsReject = ''
      this.newObservation = ''
      this.createBoxConfirm(approve ? this.$lang.Common.ConfirmApprove : this.$lang.Common.ConfirmReject, approve, 'BUDGET')
        .then(value => {
          if (value) {
            if (!this.moneyFactor || this.moneyFactor < 1 || !this.regionFactor || this.regionFactor < 1 || !this.taxesFactor || this.taxesFactor < 1) {
              toast.error(this.$lang.PCI.AT.WarningFactor)
              return
            }

            loading.push()
            this.at.obsRejeicao = this.obsReject
            this.at.statusAprovacao = approve ? this.statusApprove.APROVADA : this.statusApprove.REJEITADO_ORCAMENTO
            this.newObservation = approve ? `${new Date().toLocaleString()}: Aprovado pelo Orçamento por ${this.userInfo.nome}` : `${new Date().toLocaleString()}: Rejeitado pelo Orçamento por ${this.userInfo.nome}\nMotivo: ${this.obsReject}`

            this.onUpdate()
              .catch(err => {
                console.log(err)
                this.at.statusAprovacao = statusAprovacao
                this.at.obsRejeicao = obsRejeicao
                this.onException(err)
              })
              .finally(() => loading.close())
          }
        })
    },
    onShowObsPopover (evt, observ) {
      if (evt.target.value === observ.observacao) {
        evt.preventDefault()
      }
    },
    onUpdateObs (obs) {
      if (this.hasRole(this.roles.RW_OPER_PCI_ADM)) {
        loading.push()
        TecAnalysisRepository.UpdateObs(obs)
          .then(response => {
            if (response.data.code > 0) {
              if (!obs.observacao) {
                this.$set(this.at, 'observacoes', this.at.observacoes.filter(o => o.id !== obs.id))
              }
              toast.success(this.$lang.Common.Alerts.Success)
              this.editingObs = -1
            } else {
              toast.error(this.$lang.Common.CouldNotSave)
            }
          })
          .finally(() => loading.close())
      }
    },
    onAddObs () {
      if (this.newObservation && this.hasRole(this.roles.RW_OPER_PCI_ADM)) {
        var obs = {
          id: empty(),
          analiseTecID: this.at.id,
          observacao: this.newObservation,
          status: 1
        }

        loading.push()
        TecAnalysisRepository.UpdateObs(obs)
          .then(response => {
            if (response.data.code > 0) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.at.observacoes.push(response.data.data)
              this.newObservation = null
            } else {
              toast.error(this.$lang.Common.CouldNotSave)
            }
          })
          .finally(() => loading.close())
      }
    },
    onUpdate () {
      if (this.newObservation) {
        this.$set(this.at, 'observacoes', this.at.observacoes || [])
        this.at.observacoes.push({
          id: '00000000-0000-0000-0000-000000000000',
          analiseTecID: this.at.id,
          observacao: this.newObservation,
          status: 1
        })
        this.newObservation = ''
      }
      return TecAnalysisRepository.Update(this.clone, this.at)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = this.objList.map(at => {
              if (at.id === this.at.id) {
                at.statusAprovacao = this.at.statusAprovacao
                this.$set(this.at, 'observacoes', response.data.data.observacoes)
              }
              return at
            })

            this.clone = false

            this.onLoadAT()
            this.$emit('Update', this.at.obras)
          } else {
            throw new Error(this.$lang.Common.CouldNotSave)
          }
        })
    },
    onEditAdditive (obj) {
      if (this.budgetApprovable && this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)) {
        this.additive = obj
      }
    },
    onAddAdditive () {
      const maxOrder = this.extraItems && this.extraItems.length ? Math.max(...this.extraItems.map(o => o.ordem)) : 0
      this.additive = {
        id: '00000000-0000-0000-0000-000000000000',
        analiseTecID: this.at.id,
        origemItem: 1,
        lpuItemID: null,
        ordem: maxOrder + 1,
        sequencia: '',
        descricao: '',
        tipoItem: 0,
        tipoAgrupamento: 0,
        analiseTecItemDetalhe: {
          id: '00000000-0000-0000-0000-000000000000',
          analiseTecItemID: '00000000-0000-0000-0000-000000000000',
          valor: 0.00,
          unidade: '',
          codigoCliente: '',
          descricaoCliente: '',
          observacao: '',
          quantidade: 0.00
        }
      }
    },
    onCreateAdditive (additive) {
      loading.push()
      TecAnalysisItemRepository.Create(additive)
        .then(response => {
          if (response.data.code > 0) {
            this.extraItems.push(response.data.data)
            this.additive = null
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onDeleteAdditive (additive) {
      if (!this.budgetApprovable) return
      loading.push()
      const index = this.extraItems.findIndex(p => p.id === additive.id)
      TecAnalysisItemRepository.Delete(additive.id)
        .then(response => {
          if (response.data.code > 0) {
            this.extraItems.splice(index, 1)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdateAdditive (additive) {
      loading.push()
      const index = this.extraItems.findIndex(p => p.id === additive.id)
      TecAnalysisItemRepository.Update(additive)
        .then(response => {
          if (response.data.code > 0) {
            this.$set(this.extraItems, index, response.data.data)
            this.additive = null
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onException (err) {
      console.log(err)
      toast.error(this.$lang.Common.Alerts.Error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/tecanalysis/tecanalysis.js